import oldTemplates from './oldTemplates';
import newTemplates from './newTemplates';

const getIconTemplate = (name) => {
    return newTemplates[name] || oldTemplates[name] || oldTemplates.UNKNOWN;
};

export default (name, params = {}) => getIconTemplate(name)(params);
